
export const locationMapping: Record<string, string> = {
    // 関東
    '東京23区': 'kanto',
    '東京都': 'kanto',
    '神奈川県': 'kanto',
    '埼玉県': 'kanto',
    '千葉県': 'kanto',

    // 関西
    '大阪府': 'kansai',
    '兵庫県': 'kansai',
    '京都府': 'kansai',
    '奈良県': 'kansai',
    '和歌山県': 'kansai',

    // 名古屋
    '名古屋市': 'nagoya',
    '愛知県': 'nagoya',
    '岐阜県': 'nagoya',
    '三重県': 'nagoya',

    // 福岡
    '福岡市': 'fukuoka',
    '福岡県': 'fukuoka',
    '北九州市': 'fukuoka',
    '福岡県内': 'fukuoka',
    '久留米市': 'fukuoka',
    '佐賀県': 'fukuoka',
    '佐賀市': 'fukuoka',
    '唐津市': 'fukuoka',
    '鳥栖市': 'fukuoka',
    '佐賀県内': 'fukuoka',

    // 札幌
    '札幌市': 'sapporo',
    '小樽市': 'sapporo',
    '函館市': 'sapporo',
    '旭川市': 'sapporo',
    '千歳市': 'sapporo',
    '北海道内': 'sapporo',
    '北海道': 'sapporo',

    // その他地域はオンライン
    '仙台市内': 'online',
    '宮城県内': 'online',
    '青森県': 'online',
    '岩手県': 'online',
    '秋田県': 'online',
    '山形県': 'online',
    '福島県': 'online',
    '静岡県': 'online',
    '群馬県': 'online',
    '茨城県': 'online',
    '栃木県': 'online',
    '広島県': 'online',
    '岡山県': 'online',
    '山口県': 'online',
    '鳥取県': 'online',
    '島根県': 'online',
    '沖縄県': 'online',
    '長崎県': 'online',
    '長野県': 'online',
}
